import { useSyncExternalStore } from 'react';

/** Reactive `window.matchMedia` — re-renders when the query flips. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Tailwind `lg` breakpoint — where the app switches from mobile to desktop chrome. */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');
